import { dataLoader } from "@unbxd-ui/unbxd-react-components";
const utils = {
    addRequestConfigs: function(requestsMap = {}) {
        for (let requestId in requestsMap) {
            dataLoader.addRequestConfig(requestId, requestsMap[requestId]);
        }
    }
}
export default utils;